import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { DatatableRootObject } from '../interfaces/datatable-root-object';
import { DataTablesResponse } from '../interfaces/datatables-response';
import { ImageHeader } from '../interfaces/image-header';
const URL = `${URL_SERVICIOS}imageheader`;

@Injectable({
  providedIn: 'root'
})
export class ImageHeaderService {

  constructor(private http: HttpClient) { }

  getImagesHeader = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<ImageHeader>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS);

  getAllImageHeader = () => this.http.get<ImageHeader[]>(URL);
  
  getImageHeader = (id: number) => this.http.get<ImageHeader>(`${URL}/${id}`);

  addImageHeader = (data: ImageHeader[]) => this.http.post(URL, JSON.stringify(data), HTTP_OPTIONS);

  updateImageHeader = (id: number, data: ImageHeader) => this.http.put(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);
  
  changeImageHeader = (id: number, data: any) => this.http.patch(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);
  
  deleteImageHeader = (id: number) => this.http.delete(`${URL}/${id}`);
}
